import { styled, Button as MuiButton, ButtonProps } from '@mui/material';
import { Box } from '@mui/material';

export const CompanyCard = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'auto 1fr',
    gap: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    textAlign: 'center',
    gap: theme.spacing(2),
  },
}));

interface CompanyLogoProps {
  isDark?: boolean;
}

export const CompanyLogo = styled(Box)<CompanyLogoProps>(({ theme, isDark = false }) => ({
  width: '120px',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2),
  backgroundColor: isDark ? '#1a1a1a' : '#f8f9fa',
  borderRadius: theme.shape.borderRadius,
  transition: 'background-color 0.2s ease-in-out',
  '& img': {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    filter: isDark ? 'brightness(-1) invert(1)' : 'none',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '0 auto',
    width: '100px',
    height: '100px',
  },
}));

export const CompanyDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  justifyContent: 'center',
  '& .company-name': {
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  '& .company-description': {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1),
  },
  '& .rating-container': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    textAlign: 'center',
    '& .rating-container': {
      justifyContent: 'center',
    },
  },
}));

export const ViewDetailsButton = styled(MuiButton)<ButtonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>>(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  textTransform: 'none',
  borderRadius: '8px',
  padding: '10px 24px',
  fontWeight: 600,
  alignSelf: 'center',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'translateY(-1px)',
  },
})); 